import i18n from 'i18next';
import { DEFAULT_LOCALE, LOCALE_LIST, resolveLocale } from '@/constants/locale';
import { initReactI18next } from 'react-i18next';
import enText from './lang/en';
import jaText from './lang/ja';
import koText from './lang/ko';
import zhText from './lang/zh';
import ztText from './lang/zt';
import zhCN from 'antd/locale/zh_CN';
import ko from 'antd/locale/ko_KR';
import zhTW from 'antd/locale/zh_TW';
import en from 'antd/locale/en_US';
import ja from 'antd/locale/ja_JP';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/zh-tw';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  en: {
    translation: {
      ...enText
    },
    ...en
  },
  ja: {
    translation: {
      ...jaText
    },
    ...ja
  },
  ko: {
    translation: {
      ...koText
    },
    ...ko
  },
  zh: {
    translation: {
      ...zhText
    },
    ...zhCN
  },
  'zh-Hant': {
    translation: {
      ...ztText
    },
    ...zhTW
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

export function setLocale(locale: string): string {
  dayjs.locale(locale);
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang') || '';
  if (LOCALE_LIST.includes(lang)) {
    return lang;
  }
}

(() => {
  const defaultLocale = resolveLocale(
    getLocaleParams() || localStorage.getItem('locale') || DEFAULT_LOCALE
  );
  setLocale(defaultLocale);
})();

export default i18n;
